import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Link } from '@react-pdf/renderer';
import LogoWithSlogan from '../../../../assets/images/LogoWithSlogan.png';
import PDFIconHome from '../../Assets/PDFIconHome.png';
import PDFIconMenu from '../../Assets/PDFIconMenu.png';
import PDFIconPinOutline from '../../Assets/PDFIconPinOutline.png';
import { Farm } from 'Context/types';
import { calculatePercentageOfValues, kFormatter } from 'Helpers/helpers';
import ReactPDFChart from 'react-pdf-charts';
import { Area, Bar, CartesianGrid, ComposedChart, Legend, XAxis, YAxis } from 'recharts';

export type PageHeaderProps = {
  left_header: string;
  left_subheader: string;
  center_header: string;
  center_subheader: string;
  week_no: number;
  styles: any;
};
const PageHeader = (props: PageHeaderProps) => (
  <View
    style={{
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '0%',
      marginRight: '2%'
    }}
  >
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }}
    >
      <View
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
      >
        <Text
          style={{
            fontSize: '14px',
            marginBottom: 2,
            textAlign: 'center',
            fontWeight: 'medium'
          }}
        >
          {props.left_header}
        </Text>
        <Text
          style={{
            fontSize: '9px',
            marginBottom: 2,
            textAlign: 'left',
            fontWeight: 400,
            flexDirection: 'row',
            display: 'flex'
          }}
        >
          {props.left_subheader}
        </Text>
      </View>
      <View
        style={{
          flex: 1,
          alignItems: 'center'
        }}
      >
        <Text
          style={{
            fontSize: '14px',
            marginBottom: 2,
            textAlign: 'center',
            fontWeight: 'medium'
          }}
        >
          {`${props.center_header}`}
        </Text>
        <Text
          style={{
            fontSize: '11px',
            marginBottom: 2,
            textAlign: 'center',
            fontWeight: 400
          }}
        >
          {props.center_subheader}
        </Text>
      </View>
      <View
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'flex-end'
        }}
      >
        <Image style={{ width: '55px', padding: '2px' }} src={LogoWithSlogan}></Image>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row'
          }}
        >
          <Link src="#field-nav-list">
            <Image
              style={{ width: '14px', height: 14, marginTop: 4, marginRight: 15 }}
              src={PDFIconMenu}
            ></Image>
          </Link>
          <Link src="#cover-page">
            <Image
              style={{ width: '14px', height: 14, marginTop: 2, marginRight: 0 }}
              src={PDFIconHome}
            ></Image>
          </Link>
        </View>
      </View>
    </View>
  </View>
);

export default PageHeader;
